"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ReactDOM = require("react-dom");
var PointerEventAdapter_1 = require("./PointerEventAdapter");
var ReactHelpers_1 = require("./ReactHelpers");
/**
 * Wrap a DOM component to give it pointer events. Example that attaches a click to a div:
 *
 *    React.createElement(PointerEventWrapper, { pointerClick: () => console.log('click') },
 *      React.createElement('div')
 *    )
 *
 * When using, you can only have one child and it must render its props to a DOM component or events will not be attached.
 * If there is more than one child an exception will be thrown.
 */
var PointerEventWrapper = /** @class */ (function (_super) {
    tslib_1.__extends(PointerEventWrapper, _super);
    function PointerEventWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.pointerEventAdapter = PointerEventAdapter_1.PointerEventAdapterManager.adapterFactory();
        return _this;
    }
    PointerEventWrapper.prototype.componentDidMount = function () {
        if (this.pointerEventAdapter.didMount) {
            var domNode = ReactDOM.findDOMNode(this);
            this.pointerEventAdapter.didMount(domNode, this.props);
        }
    };
    PointerEventWrapper.prototype.componentWillUnmount = function () {
        if (this.pointerEventAdapter.willUnmount) {
            this.pointerEventAdapter.willUnmount();
        }
    };
    PointerEventWrapper.prototype.render = function () {
        var eventAttributes = this.pointerEventAdapter.getHtmlAttributes(this.props);
        // reuse the child. It could be anything - div, ul, button, etc.
        var child = React.Children.only(this.props.children);
        // tslint:disable-next-line:no-any
        var mergedEventAttributes = {};
        Object.keys(eventAttributes).forEach(function (key) {
            // tslint:disable-next-line:no-any
            mergedEventAttributes[key] = ReactHelpers_1.mergeEventHandlers(eventAttributes[key], child.props[key]);
        });
        var clonedElement = React.cloneElement(child, mergedEventAttributes, child.props.children);
        return clonedElement;
    };
    return PointerEventWrapper;
}(React.PureComponent));
exports.PointerEventWrapper = PointerEventWrapper;
/**
 * Higher Order Component to give a component pointer event capabilities
 *
 * The root child of the underlying component must render its props to a DOM component or events will not be attached.
 */
exports.PointerEventHoC = function (componentType) {
    var componentClass = ReactHelpers_1.convertToStatefulComponentClass(componentType);
    // Wrap the component in a PointerEventWrapper
    var newComponentClass = /** @class */ (function (_super) {
        tslib_1.__extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.render = function () {
            return React.createElement(PointerEventWrapper, this.props, _super.prototype.render.call(this));
        };
        return class_1;
    }(componentClass));
    newComponentClass.displayName = "PointerEventHoC(" + ReactHelpers_1.getComponentName(componentType) + ")";
    return newComponentClass;
};
// This is here only to make the type system happy. Ideally we'd use PointerEventHoC
// tslint:disable:no-any
exports.PointerEventHoCDecorator = exports.PointerEventHoC;
//# sourceMappingURL=PointerEvents.js.map